import { render, staticRenderFns } from "./email.vue?vue&type=template&id=3b1b0f10&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=3b1b0f10&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1b0f10')) {
      api.createRecord('3b1b0f10', component.options)
    } else {
      api.reload('3b1b0f10', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=3b1b0f10&", function () {
      api.rerender('3b1b0f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/rightDrawer/views/email.vue"
export default component.exports